"use client";

import CategoryCard from "@/components/app/landing/property-type/category-card";
import { buildPropertyCategoryFilterUrl } from "@/components/app/landing/property-type/build-filter-url";
import { propertyCategoryItems } from "@/components/app/landing/property-type/items";
import { useRouter } from "next/navigation";
import { useTransition } from "react";

export default function PropertyCategories({
  website_name,
}: Readonly<{
  website_name?: string;
}>) {
  const router = useRouter();
  const [isPending, startTransition] = useTransition();

  const handleCategoryClick = (propertyValue: string) => {
    startTransition(() => {
      router.push(buildPropertyCategoryFilterUrl(propertyValue));
    });
  };

  return (
    <div className="max-w-7xl w-full mx-auto px-0 lg:px-20 ">
      <h2 className="text-center text-2xl lg:text-4xl font-black text-sec-title mt-24 mb-5 md:mb-24 md:mt-0">
        لیستی از آگهی های {website_name}
      </h2>

      <div className="flex overflow-x-auto gap-4 px-4 pb-2 snap-x snap-mandatory scrollbar-hide sm:grid sm:grid-cols-2 lg:grid-cols-3 sm:gap-x-10 sm:gap-y-10 sm:overflow-visible sm:px-0 sm:pb-0 sm:snap-none">
        {propertyCategoryItems.map((item) => (
          <div
            key={item.propertyValue}
            className={`
                flex justify-center items-start transition-all duration-500 snap-start
                /* Center image in each row is higher */
                lg:nth-[3n-2]:mt-20
                lg:nth-[3n-1]:mt-0
                lg:nth-[3n]:mt-20
                /* Tablet View */
                sm:nth-[2n]:mt-16
                sm:lg:mt-0
                ${isPending ? "opacity-50 pointer-events-none" : "opacity-100"}
              `}
          >
            <CategoryCard
              title={item.title}
              image={item.image}
              onClick={() => handleCategoryClick(item.propertyValue)}
              className="group relative w-[240px] sm:w-full h-[320px] sm:h-[423.53px] shrink-0 rounded-2xl overflow-hidden mx-auto shadow-lg"
              sizes="(max-width: 640px) 240px, (max-width: 1024px) 50vw, 33vw"
            />
          </div>
        ))}
      </div>
    </div>
  );
}
